import { ChangeDetectionStrategy, Component, Input, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO, SelectConditionDO } from '../../../../../../system/system-dtos';

@Component({
  selector: 'app-table-cell-condition',
  templateUrl: './condition-table-cell.component.html',
  standalone: false,
})
export class ConditionTableCellComponent extends DataTypeComponent implements OnDestroy {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: any;

  @Input() editMode: boolean;

  condition: SelectConditionDO;

  ngOnDestroy() {}
}
